const config = {};

config.mobile = window.innerWidth < 577 ? true : false;
config.versao = "01.03.003";
config.atualizado = "26/04/2025";
config.urlApi = process.env.REACT_APP_BACKEND_URL;

console.log(`Versão: ${config.versao} atualiza em ${config.atualizado}`)

var appBasePath = process.env.REACT_APP_BASE_PATH;
if (appBasePath.length === 1) {
  appBasePath = ''
}
config.basePath = appBasePath || '';

config.routes = {
  login: "/login",
  recuperarSenha: "/recuperar-senha",
  root: "/",
  pedido: "/pedido",
  cadastro: "/pre-cadastro",
  redefinirSenha: "/redefinir-senha",
  alterarSenha: "/alterar-senha",
  perfil: "/perfil",
  administrativo: "/administrativo",
  reiniciosenha: "/reinicio-senha",
  resumo: "/resumo",
  administrativoEditar: "/administrativoeditar",
};

export default config;
